import { Box, Stack, Theme } from '@mui/material';
import Icon from '../../icon';
import Text from '../../text';
import { createUseStyles } from 'react-jss';
import { FC } from 'react';
import { getBreakpoint } from '@/theme';
import { IconType } from '../../icon/helpers';

interface Props {
  icon: IconType;
  title: string;
  description?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tabHeader: {
    margin: '0px 16px 2px 18px',
    color: theme.palette.text.primary,
  },
  tabDescription: {
    paddingTop: 8,
  },
  [getBreakpoint('md')]: {
    tabHeader: {
      borderTop: `1px solid ${theme.palette.divider}`,
      paddingTop: 8,
      margin: '0px 8px',
    },
    tabDescription: {
      paddingTop: 4,
    },
  },
}));

const TabHeader: FC<Props> = ({ icon, title, description = '' }) => {
  const styles = useStyles();
  const hasDescription = !!description;

  return (
    <Box className={styles.tabHeader}>
      <Stack direction="row" gap={1} alignItems="center">
        <Icon name={icon} />
        <Text size="large">{title}</Text>
      </Stack>
      {hasDescription && (
        <Box className={styles.tabDescription}>
          <Text size="small">{description}</Text>
        </Box>
      )}
    </Box>
  );
};

export default TabHeader;
